import { render, staticRenderFns } from "./ChatLogs.vue?vue&type=template&id=2a693b98&"
import script from "./ChatLogs.vue?vue&type=script&lang=ts&"
export * from "./ChatLogs.vue?vue&type=script&lang=ts&"
import style0 from "./ChatLogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports